import { KeyboardArrowRight } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

import Head from "../../components/Head/Head";
import Footer from "../../components/Footer/Footer";
import InstantQuote from "../../components/InstantQuote/InstantQuote";
import NavBar from "../../components/NavBar/NavBar";

import BlogContent from "../../data/blog";

import "./Article.css";

const Article = ({ match }) => {
  const history = useHistory();
  const article = match.params.article;
  const [show, setShow] = useState(false);
  const findArticle = (art) => {
    return (
      art.topic.toLowerCase() === article.split("-").join(" ").toLowerCase()
    );
  };
  const getArticle = BlogContent.find(findArticle);

  useEffect(() => {
    if (getArticle) setShow(true);
    else history.replace("/404");
  }, [getArticle, history]);

  return (
    <>
      <Head
        title={"Certified Translation services-Interpretation | localization"}
        description={getArticle.topic}
        keywords={
          "translation, interpretation, certified, services, language, conference interpreter, document, localization, translators, interpreter, translator, translation company, translation services, translation companies, translation agencies, document translation, translation services near me, translate document, document translation service, document translation services online, simultaneous interpretation services, multilingual services, sworn translators, certified translations"
        }
      />
      {show && (
        <>
          <NavBar />

          <div className="article__hero container d-flex flex-column align-center justify-end">
            <h2 className="position-relative z-2 font-bigger text-center">
              {getArticle.category}
            </h2>
            <h3 className="position-relative z-2 font-large text-center py-20">
              {getArticle.topic}
            </h3>
            <p className="position-relative z-2 font-big font-bold text-center pb-40 mb-20">
              By {getArticle.author}
            </p>
          </div>

          <div className="article__dir container d-flex align-center justify-start flex-wrap my-20">
            <div className="font-bold font-big">Blog</div>
            <KeyboardArrowRight
              style={{ fontSize: "32px" }}
              className="mx-20"
            />
            <div className="font-bold font-big">{getArticle.category}</div>
            <KeyboardArrowRight
              style={{ fontSize: "32px" }}
              className="mx-20"
            />
            <div className="font-big">{getArticle.topic}</div>
          </div>

          <div className="container article__content">
            {getArticle.content.map((art, i) => (
              <div key={art.head.concat(i)}>
                {(art.head.trim() !== "" || art.head) && (
                  <h2 className="py-20 font-subhead">{art.head}</h2>
                )}
                {(art.p.trim() !== "" || art.p) && (
                  <p className="py-10">{art.p}</p>
                )}
                {art.lists && (
                  <ul className="pl-20 ml-10">
                    {art.lists.map((list) => (
                      <li key={list}>{list}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>

          <div className="container d-flex flex-column article__author">
            <span className="font-subhead font-heavy">WRITTEN BY</span>
            <span className="font-large font-bold">{getArticle.author}</span>
          </div>

          <div className="container article__bottom">
            <InstantQuote />
          </div>
          <Footer />
        </>
      )}
    </>
  );
};

export default Article;
